import React from 'react';

import "./calendar/css/calendar.css";
import Milestone from './community-components/Milestone';

import Articles from './highlights-components/Articles';
import Service from '../../service/Service';
import Video from './highlights-components/Video';
import Multiplearticles from './highlights-components/Multiplearticles';
import PromotionalTools from './community-components/PromotionalTools';
import Preganancyinspectionschedule from './highlights-components/Preganancyinspectionschedule';
import Babythisweek from './community-components/Babythisweek';
import Vaccinationtracker from './community-components/Vaccinationtracker';

const service = new Service();

export default function ({ highlightsfeed, eleRef }) {
   
    return (
        <div className="highlight_second_section">  
                    {highlightsfeed && highlightsfeed.map((feedItem, index) =>
                    <div key={index} id={index} className="gtm-main-data" data-type={feedItem.type} alt={`${feedItem.title}`} title={`${(feedItem.data && feedItem.data[0] && feedItem.data[0].articleTitle)?feedItem.data[0].articleTitle:'' }`} data-id={`${feedItem.groupType}_${feedItem.pageNo}_${feedItem.type}`} data-articleid={`${(feedItem.data && feedItem.data[0] && feedItem.data[0].articleId)?feedItem.data[0].articleId:'' }`} data-videotitle={`${(feedItem.data && feedItem.data[0] && feedItem.data[0].title)?feedItem.data[0].title:'' }`}>
                        {feedItem.type=="articles" && 
                          <Articles feedItem={feedItem} GTMlike="gtm-highlight-like" gtmShare="gtm-highlight-share"  />
                        }
                  
                        {feedItem.type=="video" &&
                        <Video feedItem={feedItem} gtmShare="gtm-highlight-share" GTMlike="gtm-highlightVid-like" />
                        }

                        {feedItem.type=="mymilestone" &&
                        <Milestone feedItem={feedItem}/>
                        }
                        {feedItem.type=="vaccinationtracker" &&
                        <Vaccinationtracker highlightsfeed={feedItem}/>
                        }

                        {feedItem.type =="multiplearticles" &&
                        <Multiplearticles feedItem={feedItem}/>
                        }

                        {/* parenting tools*/}
                        {feedItem.type=="promotionalTools"  &&
                            <PromotionalTools highlightsfeed={feedItem}/>                    
                        }
                        {/* parenting tools*/}
                        {
                            feedItem.type=="preganancyinspectionschedule" &&
                            <Preganancyinspectionschedule feedItem={feedItem}/>
                        }

                        {/* {feedItem.type=="babythisweek" &&
                        <Babythisweek babyThisWeek={feedItem}/>
                        } */}

                   </div>
                    )
                    }
        </div>
    )
}
